import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var moduleClass = 'account-team';

var TeamPostActivation = function TeamPostActivation(_ref) {
  var postActivationDescription = _ref.postActivationDescription,
      postActivationTitle = _ref.postActivationTitle,
      postActivationUrl = _ref.postActivationUrl,
      postActivationCta = _ref.postActivationCta;
  return /*#__PURE__*/_jsxs("section", {
    className: moduleClass,
    children: [/*#__PURE__*/_jsx("h1", {
      className: "".concat(moduleClass, "__title"),
      dangerouslySetInnerHTML: {
        __html: postActivationTitle
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(moduleClass, "__description"),
      dangerouslySetInnerHTML: {
        __html: postActivationDescription
      }
    }), /*#__PURE__*/_jsx("a", {
      className: "".concat(moduleClass, "__button"),
      href: postActivationUrl,
      children: postActivationCta
    })]
  });
};

TeamPostActivation.displayName = 'TeamPostActivation';
TeamPostActivation.propTypes = {
  postActivationCta: PropTypes.string.isRequired,
  postActivationDescription: PropTypes.string.isRequired,
  postActivationTitle: PropTypes.string.isRequired,
  postActivationUrl: PropTypes.string.isRequired
};
export default TeamPostActivation;